import LimitCoinsCacheModule from "@/services/limit_coins/limit_coins_cache";
import { GETTER_LIMIT_COINS_SETTING } from "@/store/constants/setting_types";
import { LimitCoinsSettingParams, LimitSettingParamsMap } from "./types";
import { store } from "@/main";
import PaymentCache from "@/services/payment/paymentCache";
import { isDoubleCoins } from "@/utils/general_utils";

export const showLimitCoinsLogic = (restart: boolean = false) => {
  try {
    // 先判断是否显示过limitCoins
    if (!LimitCoinsCacheModule.getStartShowTime()) {
      // 不是double并且满足t1的逻辑
      return !isDoubleCoins() && judgeT1Logic();
    } else {
      // 判断是否购买过
      if (!LimitCoinsCacheModule.getPurchaseTime()) {
        return (
          (!judgeT3Logic() && !isDoubleCoins()) ||
          (judgeT4Logic() && !isDoubleCoins() && judgeRestartLogic(restart))
        );
      } else {
        return judgeT2Logic() && !isDoubleCoins() && judgeRestartLogic(restart);
      }
    }
  } catch (e) {
    console.log("init_logic e", e);
    return false;
  }
};

// 判断t1的逻辑 => 当前时间 - 启动时间 >= t1
const judgeT1Logic = () => {
  const t1 = coinsSettingParams(LimitSettingParamsMap.t1);
  const currentTime = new Date().getTime();
  const launchTime = PaymentCache.getCurrentLaunchTime();
  return currentTime - launchTime >= t1;
};

// 判断t2的逻辑 当前时间 - 购买时间 >= t2
const judgeT2Logic = () => {
  const t2 = coinsSettingParams(LimitSettingParamsMap.t2);
  const currentTime = new Date().getTime();
  const purchaseTime = LimitCoinsCacheModule.getPurchaseTime();
  console.log("judgeT2Logic", currentTime - purchaseTime, t2);
  return currentTime - purchaseTime >= t2;
};

// 判断t3的逻辑 当前时间 - limit开始出现时间 >= t3
const judgeT3Logic = () => {
  const t3 = coinsSettingParams(LimitSettingParamsMap.t3);
  const currentTime = new Date().getTime();
  const startTime = LimitCoinsCacheModule.getStartShowTime();
  return currentTime - startTime >= t3;
};

// 判断t4的逻辑 当前时间 - limit出现时间 - t3 >= t4
const judgeT4Logic = () => {
  const t3 = coinsSettingParams(LimitSettingParamsMap.t3);
  const t4 = coinsSettingParams(LimitSettingParamsMap.t4);
  const currentTime = new Date().getTime();
  const startTime = LimitCoinsCacheModule.getStartShowTime();
  return currentTime - startTime - t3 >= t4;
};

// 如果是重启，需要计算t1，否则直接显示
const judgeRestartLogic = (restart: boolean) => {
  return restart ? judgeT1Logic() : true;
};

export const getCountDownEndTime = () => {
  const t3 = coinsSettingParams(LimitSettingParamsMap.t3);
  // console.log("t3", t3);
  const startTime = LimitCoinsCacheModule.getStartShowTime();
  const purchaseTime = LimitCoinsCacheModule.getPurchaseTime();
  // console.log("startTime", startTime);
  const currentTime = new Date().getTime();
  if (purchaseTime) {
    LimitCoinsCacheModule.setTime({
      limitCoinsPurchaseTime: 0,
      limitCoinsStartShowTime: currentTime
    });
    return currentTime + t3;
  } else {
    if (currentTime > startTime + t3) {
      LimitCoinsCacheModule.setTime({
        limitCoinsStartShowTime: currentTime
      });
      return currentTime + t3;
    } else {
      return startTime + t3;
    }
  }
};

const coinsSettingParams = (type: LimitSettingParamsMap) => {
  const settingParams: LimitCoinsSettingParams =
    store.getters[GETTER_LIMIT_COINS_SETTING];
  return settingParams && settingParams[type] && settingParams[type] * 1000;
};
